import customAxios from '../../customAxios';
import { ADMIN_REJECT_MANY_WITHDRAWAL_COMPANIES } from '../../routes';

const rejectManyPay2Company = async (ids: Array<string>): Promise<any> => {
  try {return (await customAxios.put(ADMIN_REJECT_MANY_WITHDRAWAL_COMPANIES, {withdrawalsId: ids})).data;
  } catch (error: unknown) {return console.error({ADMIN_REJECT_MANY_WITHDRAWAL_COMPANIES: error});}
};

export default rejectManyPay2Company;
